import { useRef, useEffect } from 'react';
import paper from 'paper';

const DriftPreview = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    paper.setup(canvasRef.current);
    const w = paper.view.size.width;
    const h = paper.view.size.height;

    const particles = [];
    for (let i = 0; i < 70; i++) {
      const shape = new paper.Path.Circle(
        new paper.Point(Math.random() * w, Math.random() * h),
        0.8 + Math.random() * 2
      );
      shape.fillColor = '#222';
      shape.opacity = 0.3 + Math.random() * 0.7;
      particles.push({ shape, vx: (Math.random() - 0.5) * 0.5, vy: (Math.random() - 0.5) * 0.5 });
    }

    const onFrame = () => {
      // Phantom attractor moves in a slow Lissajous path
      const t = Date.now() * 0.0004;
      const mx = w / 2 + Math.sin(t * 1.3) * w * 0.25;
      const my = h / 2 + Math.sin(t * 0.7) * h * 0.25;

      particles.forEach(p => {
        const px = p.shape.position.x;
        const py = p.shape.position.y;
        const dx = mx - px, dy = my - py;
        const dist = Math.sqrt(dx * dx + dy * dy) + 1;

        p.vx += (dx / dist) * 0.04;
        p.vy += (dy / dist) * 0.04;
        p.vx += (Math.random() - 0.5) * 0.08;
        p.vy += (Math.random() - 0.5) * 0.08;
        p.vx *= 0.97;
        p.vy *= 0.97;

        let nx = px + p.vx, ny = py + p.vy;
        if (nx < 0) nx = w; if (nx > w) nx = 0;
        if (ny < 0) ny = h; if (ny > h) ny = 0;
        p.shape.position = new paper.Point(nx, ny);
      });
    };

    paper.view.on('frame', onFrame);
    return () => { paper.view.off('frame', onFrame); paper.project.clear(); };
  }, []);

  return <canvas ref={canvasRef} style={{ width: '100%', height: '100%', backgroundColor: 'white' }} />;
};

export default DriftPreview;
